import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.349 1.142a.5.5 0 0 0-.707.707L7.792 9l-7.15 7.151a.5.5 0 1 0 .707.707L8.5 9.708l7.151 7.15a.5.5 0 1 0 .707-.707l-7.15-7.15 7.15-7.152a.5.5 0 1 0-.707-.707L8.5 8.293 1.349 1.142Z"
      fill="#4D4D4D"
    />
  </svg>
);
const Memo = memo(SvgCross);
export default Memo;
